import { legacyTheme, styled } from '@prose-ui/legacy';

import {
  type ConsultationTipImage,
  ImageWithLegend,
} from 'Apps/Consultation/Components/ImageWithLegend';

const Root = styled.div`
  & > * {
    margin-bottom: ${legacyTheme.spacing.s16};
  }
`;

type ListOfImagesProps = {
  images: ConsultationTipImage[];
};

export const ListOfImages = ({ images }: ListOfImagesProps) => (
  <Root>
    {images.map((image) => (
      <ImageWithLegend
        key={String(image.alt)}
        alt={image.alt}
        legend={image.legend}
        src={image.src}
      />
    ))}
  </Root>
);
